import { render, staticRenderFns } from "./GoodReceiptEditView.vue?vue&type=template&id=5fecb498"
import script from "./GoodReceiptEditView.vue?vue&type=script&lang=js"
export * from "./GoodReceiptEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports